interface Props {
    size?: number;
    color?: string;
    onClick?: () => void;
    className?: string;
}

const CloseIcon = (props: Props) => {
    return (
        <svg
            width={props.size ?? 15}
            height={props.size ?? 15}
            viewBox="0 0 24 24"
            fill="none"
            onClick={props.onClick}
            className={props.className}
        >
            <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill={props.color ?? '#0dc648'}
            />
        </svg>
    );
};

export default CloseIcon;
